import db from '@/firebase/init'
import firebase from 'firebase'
import { getSavedSiteLocale } from '@/helpers/siteLocale'

/**
 * Firebase Auth email templates use BCP 47 codes (e.g. pt, en).
 * churchLocale and siteLang use en | pt.
 */
export function toFirebaseAuthLanguageCode(locale) {
  const raw = (locale || 'en').toLowerCase()
  if (raw.startsWith('pt')) return 'pt'
  if (raw === 'en') return 'en'
  return 'en'
}

export function applyFirebaseAuthLanguageForLocale(locale) {
  const code = toFirebaseAuthLanguageCode(locale)
  firebase.auth().languageCode = code
  return code
}

/** UI locale for self-service passwordless login ( /pt/login, siteLang, etc. ). */
export function resolveLoginEmailLinkLanguage() {
  const saved = getSavedSiteLocale()
  if (saved) {
    return toFirebaseAuthLanguageCode(saved)
  }

  if (typeof window !== 'undefined') {
    const match = window.location.pathname.match(/^\/(pt|en)(?:\/|$)/i)
    if (match) {
      return toFirebaseAuthLanguageCode(match[1])
    }
  }

  return 'en'
}

/**
 * Group invite emails follow the inviting church's market locale when set.
 * Falls back to the leader's current UI locale.
 */
export async function resolveInviteEmailLinkLanguage({ cid, rootState } = {}) {
  if (cid && rootState?.AppData?.churches?.length) {
    const church = rootState.AppData.churches.find((item) => item.cid === cid)
    if (church?.churchLocale) {
      return toFirebaseAuthLanguageCode(church.churchLocale)
    }
  }

  if (cid) {
    try {
      const snap = await db
        .collection('churches')
        .where('cid', '==', cid)
        .limit(1)
        .get()
      if (!snap.empty) {
        const churchLocale = snap.docs[0].data()?.churchLocale
        if (churchLocale) {
          return toFirebaseAuthLanguageCode(churchLocale)
        }
      }
    } catch {
      // Use UI locale when church lookup fails.
    }
  }

  return resolveLoginEmailLinkLanguage()
}
